import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../cn.js';
const SIZES = {
    sm: 'h-4 w-4 border-2',
    md: 'h-6 w-6 border-2',
    lg: 'h-9 w-9 border-[3px]',
};
export function Spinner({ size = 'md', className, label = 'Loading' }) {
    return (_jsxs("span", { role: "status", "aria-live": "polite", className: cn('inline-flex items-center justify-center', className), children: [_jsx("span", { className: cn('animate-spin rounded-full border-current border-t-transparent opacity-80', SIZES[size]) }), _jsx("span", { className: "sr-only", children: label })] }));
}
//# sourceMappingURL=Spinner.js.map